<section class="section-page" [class.visible]="isVisible">
  <div class="section-page__container">
    <a routerLink="/" class="section-page__back">← Volver al portfolio</a>
    <div class="section-page__header">
      <h1 class="section-page__title">Quién soy</h1>
      <div class="section-page__accent-line"></div>
    </div>
    <p class="section-page__intro-text">
      Soy Sergio Pulido, un desarrollador de Barcelona con formación en DAM que actualmente trabaja
      en aplicaciones web en entorno empresarial.
    </p>
    <div class="detail-grid">
      <div class="detail-card">
        <div class="detail-card__icon">
          <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="20" cy="12" r="7"/>
            <path d="M6 38c0-7.732 6.268-14 14-14s14 6.268 14 14"/>
          </svg>
        </div>
        <h3 class="detail-card__title">Sobre mí</h3>
        <p class="detail-card__text">
          Vengo de un recorrido poco lineal y eso me ha enseñado a valorar cada paso, adaptarme
          y seguir adelante incluso cuando las cosas cuestan más de lo esperado.
        </p>
      </div>
      <div class="detail-card">
        <div class="detail-card__icon">
          <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="20" cy="20" r="16"/>
            <path d="M20 8v12l8 4"/>
          </svg>
        </div>
        <h3 class="detail-card__title">Mi especialidad</h3>
        <p class="detail-card__text">
          Trabajo principalmente con Angular y TypeScript, y disfruto construyendo interfaces claras y ordenadas
          que tengan sentido para quien las usa.
        </p>
      </div>
      <div class="detail-card">
        <div class="detail-card__icon">
          <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 4l4 8 9 1.3-6.5 6.4 1.5 9L20 24.5 11.9 28.7l1.5-9L7 13.3l9-1.3z"/>
          </svg>
        </div>
        <h3 class="detail-card__title">Mi enfoque</h3>
        <p class="detail-card__text">
          Intento trabajar con cuidado, preguntar cuando no sé algo y no dar nada por supuesto.
          Para mí, ser desarrollador no es solo saber más tecnología, sino también saber trabajar bien con los demás.
        </p>
      </div>
    </div>
  </div>
</section>
